import { createSlice } from "@reduxjs/toolkit";

const contactSlice = createSlice({
  name: "contactForm",
  initialState: {
    btnForm:false,
    err:false
  },
  reducers: {
    onSub(state,{payload}) {
        state.btnForm = payload
    },
    onErr(state,{payload}) {
        state.err = payload
    }
  },
});


export const selectForm = (state) => state.contactForm
export const { onSub, onErr } = contactSlice.actions;
export default contactSlice.reducer